import React from "react";

const Test = ({item}) => {
  return <><h1>{item.data}</h1></>
};
export default Test;
